














































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class DateField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly clearable!: boolean;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;

  public dateValue = this.parseDate(this.rec[this.field]);
  public dateText = this.formatDateText(this.dateValue);
  public datePick = this.formatDatePick(this.dateValue);
  public datePickMenu = false;


  public dateTextBlur() {
    // console.log('DateField.dateTextBlur', this.dateText);
    this.saveDate(this.parseDateText(this.dateText));
  }

  public dateTextInput() {
    // console.log('DateField.dateTextInput', this.dateText);
    // this.saveDate(this.parseDateText(this.dateText));
  }

  public formatDateText(value: moment.Moment | null): string | null {
    return value ? value.format('DD-MM-YYYY') : null;
  }
  public formatDatePick(value: moment.Moment | null): string | null {
    return value ? value.format('YYYY-MM-DD') : null;
  }
  public formatDate(value: moment.Moment | null): string | null {
    return value ? value.format('YYYY-MM-DD') : null;
  }

  public parseDateText(value: string | null): moment.Moment | null {
    return value ? moment(value, 'DD-MM-YYYY').local() : null;
  }
  public parseDatePick(value: string | null): moment.Moment | null {
    return value ? moment(value, 'YYYY-MM-DD').local() : null;
  }
  public parseDate(value: string | null): moment.Moment | null {
    return value ? moment(value).local() : null;
  }

  public datePickChanged() {
    // console.log('DateField.datePickChanged', this.field, this.datePick);
    this.datePickMenu = false;
    const dt = this.parseDatePick(this.datePick);
    this.dateText = this.formatDateText(dt);
    this.saveDate(dt);
  }
  public saveDate(dt: moment.Moment | null) {
    // console.log('DateField.setDate', this.field, this.formatDate(this.dateValue), '->', this.formatDate(dt), );
    if (dt !== this.dateValue) {
      this.dateValue = dt;
      this.rec[this.field] = this.formatDate(dt);
      this.$emit('change', dt);
    }
  }

  public nextElement(e) {
    const elem = e.target;
    const currentIndex = Array.from(elem.form.elements).indexOf(elem);
    let nextElem = elem.form.elements.item(
      currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
    );
    if (nextElem.tabIndex === -1) {
      // Skip element - clear icon
      nextElem = elem.form.elements.item(
        currentIndex < elem.form.elements.length - 2 ? currentIndex + 2 : 0
      );
    }
    this.datePickMenu = false;
    nextElem.select();
    this.$emit('enter', e);
  }

  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          // console.log('DateField.$watch', this.field, oldValue, '->',  newValue);
          if (oldValue !== newValue) {
            this.dateValue = this.parseDate(newValue);
            this.datePick = this.formatDatePick(this.dateValue);
            this.dateText = this.formatDateText(this.dateValue);
          }
        }
    );
  }
}
